import useUsers from "@/hooks/useUsers";
import type { Feature } from "@/types/feature";
import { userIsCROAdmin } from "@/util";

export type FeatureAccessLevel = "none" | "read" | "write";

export type UseHasRBACAccessToFeatureResult = {
  level: FeatureAccessLevel;
  loading: boolean;
};

// TODO(CE-1016): swap this stub for the real per-feature RBAC check.
// Until then access mirrors userIsCROAdmin (see util.ts) so non-admin
// teammates land on the NoPermissionsPage rather than slipping through to
// the live feature view.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function useHasRBACAccessToFeature(
  _feature: Feature,
): UseHasRBACAccessToFeatureResult {
  const usersState = useUsers();
  return {
    level: userIsCROAdmin(usersState.currentUser) ? "write" : "none",
    loading: false,
  };
}
